import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import TesterForm from './form';

function TesterModal(props) {
  const { shown, t, tester } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [tester, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const jsx = (
    <Modal
      size="lg"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Save Tester')}
        </h5>
        <button
          onClick={() => { setModalOpen(false); props.onClose(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <TesterForm entity={tester} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { setModalOpen(false); props.onClose(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="TesterForm"
          className="btn btn-primary"
        >
          {t('Save Changes')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

TesterModal.defaultProps = {
  shown: false,
  tester: {},
  onSuccess: () => { },
  onClose: () => { },
};

TesterModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  tester: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(TesterModal));
